const handleSearch = (e, entries, setEntries, searchFields) => {
  const value = e.target.value;
  if (value === '') {
    setEntries(entries);
  } else {
    const filteredEntries = entries.filter((item) => {
      return searchFields.some((field) => {
        const nestedProperty = field
          .split('.')
          .reduce((o, k) => o && o[k], item);
        return (
          nestedProperty &&
          `${nestedProperty?.toLowerCase()}`.includes(value?.toLowerCase())
        );
      });
    });
    setEntries(filteredEntries);
  }
};

export default handleSearch;
